import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { TaxPossibleTaxableInfoLegacyUIComponent } from "./tax-possible-taxable-info-legacy.component";

@NgModule({
	declarations: [TaxPossibleTaxableInfoLegacyUIComponent],
	exports: [TaxPossibleTaxableInfoLegacyUIComponent],
	imports: [CoreModule]
})
export class TaxPossibleTaxableInfoLegacyUIModule {}
